var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.652,
    height: 20,
    viewBox: "0 0 20.652 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_search-normal",
    "data-name": "vuesax/bold/search-normal",
    transform: "translate(-427.674 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal",
    transform: "translate(428 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "infinity-svgrepo-com_1_",
    "data-name": "infinity-svgrepo-com (1)",
    d: "M17.088,8c4.753,0,4.753,7.461,0,7.461S10.436,8,5.207,8c-4.276,0-4.276,7.461,0,7.461C10.436,15.461,12.336,8,17.089,8Z",
    transform: "translate(-1.326 -1.23)",
    fill: "none",
    stroke: "#6361ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpLogo);
export default __webpack_public_path__ + "static/media/erp-logo.eb1c20dd73b3a5d6fb50b09e7b87e676.svg";
export { ForwardRef as ReactComponent };